import create from 'utils/createReduxPromiseActionType'

export const LOAD = create('fonts/LOAD')
export const SET_FONT_IS_LOADED = 'fonts/SET_FONT_IS_LOADED'
